import http from "../http-common";

const adminAll = () => {
  return http.get(`/v1/users`);
};

const getAll = (loc) => {
  return http.get(`/v1/users/loc/${loc}`);
};

const getAllClients = (loc) => {
  return http.get(`/v1/users/clients/loc/${loc}`);
};

const getAllEmployees = (loc) => {
  return http.get(`/v1/users/employees/loc/${loc}`);
};

const adminAllCreatedToday = () => {
  return http.get(`/v1/users/created/today`);
};

const getAllCreatedToday = (loc) => {
  return http.get(`/v1/users/loc/${loc}/created/today`);
};

const adminAllFired = () => {
  return http.get(`/v1/users/off`);
};

const getAllFired = (loc) => {
  return http.get(`/v1/users/loc/${loc}/off`);
};

const getByQRCode = (qr_code) => {
  return http.get(`/v1/users/qr/${qr_code}`);
};

const getOne = (id) => {
  return http.get(`/v1/users/${id}`);
};

const create = (data) => {
  return http.post("/v1/users", data);
};

const bulkCreate = (users) => {
  return http.post("/v1/users/bulk", users);
};

const update = (sap, data) => {
  return http.put(`/v1/users/${sap}`, data);
};

const remove = (sap) => {
  return http.delete(`/v1/users/${sap}`);
};

const removeAll = () => {
  return http.delete(`/v1/users`);
};

const bulkDelete = (userIds) => {
  return http.delete("/v1/users/bulk", { data: { userIds } });
};

// const findByFullName = fullname => {
//     return http.get(`/v1/users?fullname=${fullname}`);
// };

export default {
  adminAll,
  getAll,
  getAllClients,
  getAllEmployees,
  adminAllCreatedToday,
  getAllCreatedToday,
  adminAllFired,
  getAllFired,
  getByQRCode,
  getOne,
  create,
  bulkCreate,
  update,
  remove,
  removeAll,
  bulkDelete,
  // findByFullName
};
